<template>
  <div class="box_wrap">
    <h2 class="title">Informações adicionais</h2>
    <div class="long-description box" v-html="longDescription">
    </div>
    <small class="product-id-small">(Código item: {{ productId }})</small>
  </div>
</template>

<script>
export default {
  props: ['longDescription', 'productId'],
}
</script>

<style>
  .product-id-small {
    font-size: 12px;
    color: hsla(0, 0%, 50%, 1);
  }
  @media (max-width: 992px) {
    .long-description {
      border-radius: 0px !important;
      border: none !important;
      background: none !important;
    }

    .box {
      gap: 0px;
    }
    .box ul{
      padding: 0 0 0 1rem;
    }
  }
  @media (min-width: 992px) {
    .long-description {
      gap: 0px;
    }
    
    .box ul{
      padding: 0 0 0 1rem;
    }
  }
</style>
